export default __webpack_public_path__ + "static/media/Al Safeer Steel.788c1617.jpeg";